import Page from 'src/help/index';

export default Page;
